export const TENANT_ID = "nlo-cases" as const;

export const PIPELINE_STAGES = [
  "new",
  "review",
  "pursue",
  "drafted",
  "approved",
  "mailed",
  "retained",
  "closed",
] as const;

export type PipelineStage = (typeof PIPELINE_STAGES)[number];

/** MCP / automated write tools may only apply these transitions. */
export const MCP_ALLOWED_TRANSITIONS: Record<string, PipelineStage[]> = {
  new: ["review", "closed"],
  review: ["pursue", "closed"],
  pursue: ["drafted", "closed"],
};

/** Human UI may apply additional transitions (approve/mail/retain/etc.). */
export const HUMAN_ALLOWED_TRANSITIONS: Record<string, PipelineStage[]> = {
  ...MCP_ALLOWED_TRANSITIONS,
  drafted: ["approved", "closed"],
  approved: ["mailed", "closed"],
  mailed: ["retained", "closed"],
  retained: ["closed"],
  closed: [],
};

export const CASE_DESKS = [
  "patent",
  "ada",
  "coverage",
  "injury",
  "workplace",
  "maritime",
  "trucking",
  "aviation",
  "cases",
] as const;

export type CaseDesk = (typeof CASE_DESKS)[number];
export const FORECLOSURE_DESK = "foreclosure" as const;
export type DeskId = CaseDesk | typeof FORECLOSURE_DESK;

export type Jurisdiction = "TX" | "OK" | "OTHER";

export type LetterStatus = "draft" | "approved" | "mailed" | "void";
export type LabelBatchStatus = "draft" | "approved" | "printed" | "mailed";
export type SuggestionStatus = "open" | "accepted" | "rejected" | "done";

export type LabelFormat =
  | "avery-5160"
  | "avery-5163"
  | "dymo-30252"
  | "dymo-30321"
  | "csv";

export interface WorkupRow {
  tenant_id: string;
  desk: string;
  item_id: string;
  stage: PipelineStage;
  close_reason: string | null;
  counsel_appeared: number | null;
  mail_name: string | null;
  mail_address: string | null;
  address_source: string | null;
  address_verified: number;
  quoted_fee: number | null;
  cash_in: number | null;
  outcome: string | null;
  notes: string | null;
  do_not_contact: number;
  score: number | null;
  rule_version: string | null;
  updated_by: string | null;
  updated_at: string;
}

export interface MailAddressInput {
  name: string;
  address: string;
  source: string;
  verified: boolean;
}

/** Legacy localStorage workup stages → pipeline stages */
export const LEGACY_STAGE_MAP: Record<string, { stage: PipelineStage; close_reason?: string; dnc?: boolean }> = {
  new: { stage: "new" },
  address_confirmed: { stage: "review" },
  letter_sent: { stage: "mailed" },
  no_response: { stage: "review" },
  call_in: { stage: "pursue" },
  consult_set: { stage: "pursue" },
  retained: { stage: "retained" },
  refer: { stage: "closed", close_reason: "refer" },
  dead: { stage: "closed", close_reason: "dead" },
  do_not_contact: { stage: "closed", close_reason: "do_not_contact", dnc: true },
};
